import { isMemberDetailResponse, } from '@urbanik/api-contracts';
export class UpdateMemberApiError extends Error {
    kind;
    currentVersion;
    constructor(kind, message, currentVersion) {
        super(message);
        this.kind = kind;
        this.currentVersion = currentVersion;
        this.name = 'UpdateMemberApiError';
    }
}
export async function updateMember(baseUrl, id, input) {
    let response;
    try {
        response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}`, {
            method: 'PATCH',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify(input),
        });
    }
    catch {
        throw new UpdateMemberApiError('unavailable', 'No pudimos actualizar el socio.');
    }
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        throw new UpdateMemberApiError('invalid', 'El servidor devolvió una respuesta inválida.');
    }
    const p = payload;
    const message = typeof p.message === 'string' ? p.message : 'No pudimos actualizar el socio.';
    if (response.status === 400)
        throw new UpdateMemberApiError('validation', message);
    if (response.status === 401)
        throw new UpdateMemberApiError('unauthorized', message);
    if (response.status === 403)
        throw new UpdateMemberApiError('forbidden', message);
    if (response.status === 404)
        throw new UpdateMemberApiError('not-found', message);
    if (response.status === 409 && p.code === 'MEMBER_VERSION_CONFLICT')
        throw new UpdateMemberApiError('version-conflict', message, typeof p.currentVersion === 'number' ? p.currentVersion : undefined);
    if (response.status === 409 && p.code === 'MEMBER_NATIONAL_ID_CONFLICT')
        throw new UpdateMemberApiError('national-id-conflict', message);
    if (response.status === 409 && p.code === 'MEMBER_EMAIL_CONFLICT')
        throw new UpdateMemberApiError('email-conflict', message);
    if (!response.ok)
        throw new UpdateMemberApiError('unavailable', message);
    if (!isMemberDetailResponse(payload))
        throw new UpdateMemberApiError('invalid', 'El contrato de edición no es válido.');
    return payload;
}
